import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.function.name.js";
import i18n from 'i18next';
import isZipFile from 'utils/isZipFile';
import isScormOrMicrosite from 'utils/isScormOrMicrosite';
import { setAlert } from 'actions/alerts';
export function validateZipFiles(_x) {
  return _validateZipFiles.apply(this, arguments);
}
function _validateZipFiles() {
  _validateZipFiles = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var isZip, _yield$isScormOrMicro, isScormOrMicrositeZip, isMicrosite, isScorm;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // Check if file is a zip file
          isZip = isZipFile(file);
          if (isZip) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", {
            isZip: isZip,
            isScormOrMicrositeZip: false
          });
        case 3:
          _context.prev = 3;
          _context.next = 6;
          return isScormOrMicrosite(file);
        case 6:
          _yield$isScormOrMicro = _context.sent;
          isScormOrMicrositeZip = _yield$isScormOrMicro.isValid;
          isMicrosite = _yield$isScormOrMicro.isMicrosite;
          isScorm = _yield$isScormOrMicro.isScorm;
          return _context.abrupt("return", {
            isZip: isZip,
            isScormOrMicrositeZip: isScormOrMicrositeZip,
            isScorm: isScorm,
            isMicrosite: isMicrosite
          });
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](3);
          setAlert({
            title: i18n.t('alert_zip_file_validation_error', {
              name: file.name
            })
          });
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 13]]);
  }));
  return _validateZipFiles.apply(this, arguments);
}